import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { ModelComponentComponent } from './components/model-component.component';
import { ModelComponentRoutingModule } from './model-component-routing.module';

@NgModule({
  declarations: [ModelComponentComponent],
  imports: [
    ModelComponentRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    PageModule
  ],
})
export class ModelComponentModule {}

export function loadModelComponentModuleAsChild() {
  return Promise.resolve(ModelComponentModule);
}
